const ROUTE_STEP_MAP: Record<string, string> = {
    'postal-code': 'postal_code',
    home: 'general_questions',
    'renovation-categories.index': 'renovation_category',
    'renovation-categories.questions':
        'technique_pre_qualification_questions_{renovation_category_key}',
    'renovation-categories.techniques.index': 'technique_selection',
    'techniques.show': 'technique_selection',
    'techniques.questions': 'technique_questions_{technique_key}',
    'personal-details': 'personal_details',
    'business-details': 'business_details',
    result: 'result',
}

export function stepNameForRoute(
    routeName: string,
    techniqueKey?: string | null,
    renovationCategoryKey?: string | null
): string | undefined {
    const stepName = ROUTE_STEP_MAP[routeName]

    if (stepName?.includes('{technique_key}')) {
        return techniqueKey ? stepName.replace('{technique_key}', techniqueKey) : undefined
    }

    if (stepName?.includes('{renovation_category_key}')) {
        return renovationCategoryKey
            ? stepName.replace('{renovation_category_key}', renovationCategoryKey)
            : undefined
    }

    return stepName
}
